import { createContext } from 'react';

const ListerContext = createContext();

export default ListerContext;
